import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useHistory, Redirect } from "react-router-dom";

export default function Signup() {
    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const { signup, currentUser } = useAuth();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    if (currentUser) {
        return <Redirect to="/" />;
    } else {
        async function handleSubmit(e) {
            e.preventDefault();

            if (
                passwordRef.current.value !== passwordConfirmRef.current.value
            ) {
                return setError("Passwords do not match");
            }

            try {
                setError("");
                setLoading(true);
                await signup(emailRef.current.value, passwordRef.current.value);
                history.push("/");
            } catch {
                setError("Failed to create an account");
            }

            setLoading(false);
        }

        return (
            <>
                <Card className="join-user">
                    <Card.Body>
                        <h2 className="text-center mb-4">Sign Up</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="form-grp" id="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    ref={emailRef}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="form-grp" id="password">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    ref={passwordRef}
                                    required
                                />
                            </Form.Group>
                            <Form.Group
                                className="form-grp"
                                id="password-confirm"
                            >
                                <Form.Label>Password Confirmation</Form.Label>
                                <Form.Control
                                    type="password"
                                    ref={passwordConfirmRef}
                                    required
                                />
                            </Form.Group>
                            <Button
                                className="w-100 btnform"
                                disabled={loading}
                                type="submit"
                            >
                                Sign Up
                            </Button>
                        </Form>
                    </Card.Body>
                    <Card.Footer className="w-100 text-center mt-2">
                        Already have an account? <Link to="/login">Log In</Link>
                    </Card.Footer>
                </Card>
            </>
        );
    }
}
